import { getBackendUrl } from "@Utils";
import axiosWrapper from "../services/axiosWrapper";
import { TOAST_TYPE_ERROR, TOAST_TYPE_SUCCESS } from "../services/constants";
import { showToastNotification } from "./toast";
import {
  setTaskData,
  setTaskCost,
  setTaskTypes,
  setTaskDetails,
  setScheduleDetails,
  deleteScheduleDetails,
  setScheduleSliderTime,
  setSelectionSetTaskElements,
} from "../reducers/Tasks";

export {
  setTaskData,
  setTaskCost,
  setTaskTypes,
  setTaskDetails,
  setScheduleDetails,
  deleteScheduleDetails as clearScheduleDetails,
  setScheduleSliderTime,
  setSelectionSetTaskElements,
};
import i18n from "@i18n";

const { t } = i18n;

export function saveTaskData(data) {
  return async (dispatch) => {
    const res = await axiosWrapper.post(`${getBackendUrl()}/tasks/saveTasksData`, data);

    const displayTask = data.title;
    if (res.data.status) {
      dispatch(
        showToastNotification({
          content: `${displayTask} has been ${data.id ? "edited" : "created"} successfully!`,
        }),
      );
    }
  };
}

export function getTaskData(params) {
  return async (dispatch) => {
    let urlParams = "";
    let postData = {};

    if (params.byPortal) {
      urlParams = "/tasks/getTasksDataByPortal";
      postData = {
        filter: {
          limit: 5,
        },
      };
    } else if (params.projectId) {
      urlParams = "/tasks/getTasksDataByProject";
      postData = {
        projectId: params.projectId,
        filter: {
          limit: 3,
        },
      };
    } else if (params.taskId) {
      urlParams = "/tasks/getTaskDetails";
      postData = {
        taskId: params.taskId,
      };
    }

    const response = await axiosWrapper.post(`${getBackendUrl()}${urlParams}`, postData);
    if (response.data.status) {
      dispatch(setTaskData({ ...response.data.data, ...response.data.metadata }));
    }
  };
}

export function getTaskDetails(params) {
  return async (dispatch) => {
    const urlParams = "/tasks/getTaskDetails";
    const postData = {
      taskId: params.taskId,
    };

    const response = await axiosWrapper.post(`${getBackendUrl()}${urlParams}`, postData);
    if (response.data.status) {
      dispatch(setTaskDetails({ ...response.data.data }));
    }
  };
}

export function saveScheduleData(data) {
  return async (dispatch) => {
    const res = await axiosWrapper.post(`${getBackendUrl()}/tasks/saveScheduleData`, data);
    if (data._id) {
      dispatch(
        showToastNotification({
          content: `${data.title} has been successfully edited`,
          type: TOAST_TYPE_SUCCESS,
        }),
      );
    } else {
      dispatch(
        showToastNotification({
          content: `${data.title} has been successfully created`,
          type: TOAST_TYPE_SUCCESS,
        }),
      );
    }
    return res;
  };
}

export function deleteSchedule(data) {
  return async (dispatch) => {
    const response = await axiosWrapper.post(`${getBackendUrl()}/tasks/deleteSchedule`, data);
    if (response.data.status) {
      dispatch(
        showToastNotification({
          content: t("Selected schedule(s) has been deleted successfully"),
          type: TOAST_TYPE_SUCCESS,
        }),
      );
    } else {
      dispatch(
        showToastNotification({
          content: t("Something went wrong"),
          type: TOAST_TYPE_ERROR,
        }),
      );
    }
  };
}

export function getScheduleDetails(params) {
  return async (dispatch) => {
    const response = await axiosWrapper.post(`${getBackendUrl()}/tasks/getScheduleDetails`, {
      ganttId: params.ganttId,
    });

    if (response.data.data) {
      dispatch(setScheduleDetails(response.data.data));
    }
  };
}

export function saveTaskTypeData(data) {
  return async (dispatch) => {
    await axiosWrapper.post(`${getBackendUrl()}/tasks/saveTaskType`, data);
    if (data._id) {
      dispatch(
        showToastNotification({
          content: t("Task type has been edited successfully!"),
          type: TOAST_TYPE_SUCCESS,
        }),
      );
    } else {
      dispatch(
        showToastNotification({
          content: t("Task type has been created successfully!"),
          type: TOAST_TYPE_SUCCESS,
        }),
      );
    }
  };
}

export function deleteTaskType(data) {
  return async () => {
    const res = await axiosWrapper.post(`${getBackendUrl()}/tasks/deleteTaskType`, data);
    return res;
  };
}

export function getTaskTypes(params) {
  return async (dispatch) => {
    const urlParams = "/tasks/getTaskTypes";
    const postData = {
      projectId: params.projectId,
    };
    const response = await axiosWrapper.post(`${getBackendUrl()}${urlParams}`, postData);
    if (response.data.result.length) {
      dispatch(setTaskTypes(response.data.result));
    }
  };
}

export function saveScheduleFile(data) {
  return async (dispatch) => {
    const response = await axiosWrapper.post(`${getBackendUrl()}/tasks/saveScheduleFile`, data);
    if (response.data.status) {
      dispatch(
        showToastNotification({
          content: t("File has been added successfully!"),
          type: TOAST_TYPE_SUCCESS,
        }),
      );
    } else {
      dispatch(
        showToastNotification({
          content: t("Error!"),
          type: TOAST_TYPE_ERROR,
        }),
      );
    }
  };
}

export function upgradeScheduleFileVersion(data) {
  return async (dispatch) => {
    const response = await axiosWrapper.post(`${getBackendUrl()}/tasks/upgradeScheduleFileVersion`, data);
    if (response.data.status) {
      dispatch(
        showToastNotification({
          content: t("File has been upgraded successfully!"),
          type: TOAST_TYPE_SUCCESS,
        }),
      );
    } else {
      dispatch(
        showToastNotification({
          content: t("Error!"),
          type: TOAST_TYPE_ERROR,
        }),
      );
    }
  };
}
export function deleteScheduleFile(data) {
  return async () => {
    await axiosWrapper.post(`${getBackendUrl()}/tasks/deleteScheduleFile`, data);
  };
}

export function assignTasksToSchedule(data) {
  return async (dispatch) => {
    await axiosWrapper.post(`${getBackendUrl()}/tasks/assignTasksToSchedule`, data);
    dispatch(
      showToastNotification({
        content: t("Tasks have been successfully added"),
        type: TOAST_TYPE_SUCCESS,
      }),
    );
  };
}

export function getSelectionSetElements(data) {
  return async (dispatch) => {
    const response = await axiosWrapper.post(`${getBackendUrl()}/tasks/getSelectionSetElements`, data);
    dispatch(setSelectionSetTaskElements(response.data.data));
  };
}
export async function updateTaskFieldsOfScheduleTask(data) {
  const response = await axiosWrapper.post(`${getBackendUrl()}/tasks/updateTaskFieldsOfScheduleTask`, data);
  return response;
}

export async function importScheduleTasks(data) {
  const response = await axiosWrapper.post(`${getBackendUrl()}/tasks/importScheduleTasks`, data);
  return response;
}

export async function importScheduleTasksNew(data) {
  const response = await axiosWrapper.post(`${getBackendUrl()}/tasks/importScheduleTasksNew`, data);
  return response;
}
